import { render } from "./PlanCategoryDetail.vue?vue&type=template&id=40ec2d62"
import script from "./PlanCategoryDetail.vue?vue&type=script&lang=js"
export * from "./PlanCategoryDetail.vue?vue&type=script&lang=js"

import "./PlanCategoryDetail.vue?vue&type=style&index=0&id=40ec2d62&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__